<template>
  <article class="act-expo" :class="{ mobile: isMobile }">
    <div class="l-one hero-headers">
      <div class="l-one__col l-one__col--wide">
        <h1>Powering your business with cutting-edge solutions</h1>
        <p>
          Learn more about how you can attract new and repeat customers to your business with Electrify America’s
          charging infrastructure customized solutions.
        </p>
      </div>
    </div>
    <div class="l-one--has-bg l-one--padding-bottom">
      <div class="l-one__col l-one__col--wide">
        <div class="form-title">
          <h2>Submit the form below to learn more.</h2>
        </div>
        <form id="event-connect" name="event-connect" class="form" @submit.prevent="validate" ref="form">
          <p aria-hidden="true" class="form-legend">An asterisk (<span>*</span>) indicates a required field</p>
          <label for="first_name"
            >First Name <span class="require-mark" aria-hidden="true">*</span>
            <input
              id="first_name"
              maxlength="55"
              name="first_name"
              pattern="^[A-Za-z '\-\.]+$"
              title="This field only accepts letters"
              type="text"
              v-model="answers['SuppliedFirstName']"
              required
            />
          </label>
          <label for="last_name"
            >Last Name <span class="require-mark" aria-hidden="true">*</span>
            <input
              id="last_name"
              maxlength="55"
              name="last_name"
              required
              pattern="^[A-Za-z '\-\.]+$"
              title="This field only accepts letters"
              type="text"
              v-model="answers['SuppliedLastName']"
            />
          </label>
          <label ref="email" for="email"
            >Business Email <span class="require-mark" aria-hidden="true">*</span>
            <input
              id="email"
              maxlength="55"
              name="email"
              required
              type="text"
              pattern="^[^\\]+@[^\\]+\.[^\\]+$"
              title="Please enter the correct email address"
              v-model="answers['SuppliedEmail']"
            />
          </label>
          <label for="phone"
            >Phone Number <span class="require-mark" aria-hidden="true">*</span>
            <input
              id="phone"
              maxlength="10"
              name="phone"
              v-model="answers['PhoneNumber']"
              type="text"
              pattern="^\d+$"
              title="This field only accepts numbers"
              required
            />
          </label>
          <label for="company_name"
            >Company Name <span class="require-mark" aria-hidden="true">*</span>
            <input
              id="company_name"
              maxlength="55"
              name="company_name"
              required
              pattern="^[^\\]+$"
              title="Please enter your company name (no special characters)"
              type="text"
              v-model="answers['CompanyName']"
            />
          </label>
          <label for="job_title"
            >Job Title <span class="require-mark" aria-hidden="true">*</span>
            <input
              id="job_title"
              maxlength="55"
              name="job_title"
              required
              pattern="^[^\\]+$"
              title="Please enter your title at the company (no special characters)"
              type="text"
              v-model="answers['JobTitle']"
            />
          </label>

          <div class="input-field checkbox">
            <label for="further-communication" class="checkbox">
              <input
                v-model="answers['OptMeinFutureComm']"
                id="further-communication"
                name="further-communication"
                type="checkbox"
                value="true"
              />
              I agree to receive further information from Electrify America*
            </label>
            <p class="form-question">*I am aware that I may unsubscribe to electronic communication at any time.</p>
            <p class="form-question">
              Click <router-link class="link" :to="{ name: 'privacy-en' }" target="_blank">here</router-link> for
              Electrify America's Privacy Statement.
            </p>
          </div>

          <div>
            <input
              ref="submitButton"
              class="button button--submit"
              name="submit"
              type="submit"
              value="Submit"
              style="width: 200px"
            />
          </div>
          <p v-show="serverError !== ''" class="server-error">
            Error:
            <br />
            {{ serverError }}
          </p>
        </form>
      </div>
    </div>
  </article>
</template>

<script>
import ApiService from '@/services/Api';

export default {
  name: 'Event Connect',
  metaInfo: {
    title: 'P66 2026 | Electrify America',
    meta: [
      {
        name: 'description',
        content: '', // Missing description.
      },
      { name: 'robots', content: 'noindex' },
    ],
    link: [{ rel: 'canonical', href: 'https://www.electrifyamerica.com/event-connect/' }],
  },
  data() {
    return {
      answers: {
        SuppliedFirstName: '',
        SuppliedLastName: '',
        SuppliedEmail: '',
        PhoneNumber: '',
        CompanyName: '',
        JobTitle: '',
        OptMeinFutureComm: '',
        Source: 'P66 2026',
        utm_source: this.$route.query.utm_source,
        utm_medium: this.$route.query.utm_medium,
        utm_campaign: this.$route.query.utm_campaign,
        utm_term: this.$route.query.utm_term,
        utm_content: this.$route.query.utm_content,
      },
      serverError: '',
    };
  },
  methods: {
    async validate(e) {
      e.preventDefault();
      this.serverError = '';

      try {
        const params = {
          site: 'ELAM',
          recaptchaToken: await this.recaptcha(),
          body: this.answers,
        };
        this.putACTExpo(params);
      } catch (error) {
        console.error(error);
      }
    },
    async recaptcha() {
      try {
        // Wait for recaptcha loading
        await this.$recaptchaLoaded();
        // Execute reCAPTCHA with action "login" and return the token
        return await this.$recaptcha('login');
      } catch (e) {
        throw new Error('recaptcha login failed');
      }
    },
    putACTExpo(params) {
      const loader = this.$loading.show();
      this.$store.commit('setEmail', params.body.SuppliedEmail);
      ApiService.init();
      ApiService.put('/v1/salesforce/actexpo', params)
        .then((res) => {
          if (res.status === 'success') {
            this.$router.push({ name: 'thanks-en' });
          } else {
            this.serverError = res.errorMsg;
          }
          loader.hide();
          this.$refs.submitButton.disabled = false;
        })
        .catch((error) => {
          // Commenting out surfacing Salesforce errors to end users until we've made messaging more robust
          /*
          if (error.response.status === 500) {
            this.serverError = 'There was an error submitting the form, please try again';
          } else {
            this.serverError = error.response.data.errMsg;
          }
          */
          this.serverError = 'There was an error submitting the form, please try again';

          this.$refs.submitButton.disabled = false;
          loader.hide();
          console.error(error);
        });
    },
  },
  mounted() {
    this.$recaptchaLoaded().then(() => {
      this.$recaptchaInstance.showBadge();
    });
  },
  beforeDestroy() {
    this.$recaptchaInstance.hideBadge();
  },
  watch: {
    serverError(newValue) {
      if (newValue !== '') {
        if (newValue.includes('Email')) {
          this.$refs.email.style.color = '#d90041';
          this.$refs.email.scrollIntoView();
        } else if (newValue.includes('Serial')) {
          this.$refs.serial.style.color = '#d90041';
          this.$refs.serial.scrollIntoView();
        }
      }
    },
  },
  computed: {
    isMobile() {
      return this.$resize && this.$mq.below(1130);
    },
  },
};
</script>

<style scoped lang="scss">
.act-expo {
  label {
    max-width: 710px;
    display: block;
  }
  label.checkbox {
    display: flex;
    input {
      margin: 0 15px 0px 0;
    }
  }
  .hero-headers {
    padding-top: 50px;
    padding-bottom: 50px;
  }
  .form-title {
    padding-top: 75px;
  }
  .form-agreement {
    font-weight: 400;
  }
  .form {
    width: 90%;
    .inline-inputs {
      margin-top: 40px;
      .group-one {
        display: flex;
        justify-content: space-between;
        @media screen and (max-width: 1000px) {
          flex-direction: column;
        }
      }
    }
  }
}
</style>
